// extracted by mini-css-extract-plugin
module.exports = {"container":"Collections_container__3aTgC","heading":"Collections_heading__Y2itb","tiles":"Collections_tiles__36WGl","tile":"Collections_tile__gOtz1"};